/** Shared percent formatting for the modern odds surfaces (OddsPanel block,
 *  OddsModal recap, OddsBar rows). Price formatting lives in
 *  `modules/currency` — call `formatPrice(amountCents, currency)` directly. */

export function formatPercent(value: number): string {
  if (!Number.isFinite(value)) return '0';
  return Number.isInteger(value)
    ? String(value)
    : value.toFixed(2).replace(/\.?0+$/, '');
}
